"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeFilterModel = exports.TOP_POLICY_WIDGET_TYPES = void 0;
const core_1 = require("@veeam/core");
var TOP_POLICY_WIDGET_TYPES;
(function (TOP_POLICY_WIDGET_TYPES) {
    TOP_POLICY_WIDGET_TYPES["snapshot"] = "snapshot";
    TOP_POLICY_WIDGET_TYPES["backup"] = "backup";
    TOP_POLICY_WIDGET_TYPES["archive"] = "archive";
})(TOP_POLICY_WIDGET_TYPES = exports.TOP_POLICY_WIDGET_TYPES || (exports.TOP_POLICY_WIDGET_TYPES = {}));
class TypeFilterModel extends core_1.Model {
    constructor(initialValue = TypeFilterModel.INITIAL_VALUE) {
        super(initialValue);
    }
    static isArchiveType(type) {
        return type === TOP_POLICY_WIDGET_TYPES.archive;
    }
    static isBackupType(type) {
        return type === TOP_POLICY_WIDGET_TYPES.backup;
    }
    static isSnapshotType(type) {
        return type === TOP_POLICY_WIDGET_TYPES.snapshot;
    }
}
exports.TypeFilterModel = TypeFilterModel;
TypeFilterModel.INITIAL_VALUE = {
    type: TOP_POLICY_WIDGET_TYPES.backup,
};
//# sourceMappingURL=TypeFilterModel.js.map